import React, { useState, useEffect } from 'react';
import { Phone, Menu, X } from 'lucide-react';
import Logo from './Logo';

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setIsMobileMenuOpen(false);
    }
  };

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-400 ${
        isScrolled ? 'bg-black/95 backdrop-blur-md border-b border-white/10' : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-20">
          {/* Logo */}
          <div className="flex-shrink-0 cursor-pointer" onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}>
            <Logo />
          </div>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center space-x-8">
            <a
              href="http://auto-repair-env.eba-n2mgpe4i.us-east-2.elasticbeanstalk.com/form"
              target="_blank"
              rel="noopener noreferrer"
              className="text-white/70 hover:text-white text-base font-medium transition-colors duration-300"
            >
              Staff Portal
            </a>
            <button
              onClick={() => scrollToSection('about')}
              className="text-white/70 hover:text-white text-base font-medium transition-colors duration-300"
            >
              About
            </button>
            <button
              onClick={() => scrollToSection('services')}
              className="text-white/70 hover:text-white text-base font-medium transition-colors duration-300"
            >
              Services
            </button>
            <button
              onClick={() => scrollToSection('contact')}
              className="text-white/70 hover:text-white text-base font-medium transition-colors duration-300"
            >
              Contact
            </button>
            <a
              href="tel:7742425144"
              className="flex items-center gap-2 bg-red-600 hover:bg-red-700 text-white px-6 py-3 font-medium transition-all duration-300 hover:scale-105"
              style={{ borderRadius: '0px' }}
            >
              <Phone size={18} />
              Call Now
            </a>
          </nav>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className="md:hidden text-white p-2"
          >
            {isMobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      {isMobileMenuOpen && (
        <div className="md:hidden bg-black/98 backdrop-blur-md border-t border-white/10">
          <div className="px-4 py-4 space-y-3">
            <a
              href="http://auto-repair-env.eba-n2mgpe4i.us-east-2.elasticbeanstalk.com/form"
              target="_blank"
              rel="noopener noreferrer"
              className="block w-full text-left text-white/70 hover:text-white py-2 text-base font-medium transition-colors"
            >
              Staff Portal
            </a>
            <button
              onClick={() => scrollToSection('about')}
              className="block w-full text-left text-white/70 hover:text-white py-2 text-base font-medium transition-colors"
            >
              About
            </button>
            <button
              onClick={() => scrollToSection('services')}
              className="block w-full text-left text-white/70 hover:text-white py-2 text-base font-medium transition-colors"
            >
              Services
            </button>
            <button
              onClick={() => scrollToSection('contact')}
              className="block w-full text-left text-white/70 hover:text-white py-2 text-base font-medium transition-colors"
            >
              Contact
            </button>
            <a
              href="tel:7742425144"
              className="flex items-center justify-center gap-2 bg-red-600 hover:bg-red-700 text-white px-6 py-3 font-medium transition-all duration-300 w-full"
              style={{ borderRadius: '0px' }}
            >
              <Phone size={18} />
              Call Now
            </a>
          </div>
        </div>
      )}
    </header>
  );
};

export default Header;